import qs from "qs-lite";
import { useMutation, useQuery, useQueryClient } from "react-query";
import api from "../../utils/api";
import { getQueryParams } from "../../helpers";
import { useHubSnackBar } from "../useSnackBar";

const INDUSTRY = "/industry";
const CACHE_TIME = 30_600_000;

const getAllIndustryData = ({ queryKey }) => {
  const queryString = qs.stringify(queryKey[1]);
  return api.get(`${INDUSTRY}?${queryString}`);
};

export const useGetAllIndustryData = () => {
  const queryProps = getQueryParams({ prefix: "industries" });
  return useQuery([INDUSTRY, queryProps], getAllIndustryData, {
    keepPreviousData: true,
  });
};

const getIndustryList = () => {
  return api.get(`${INDUSTRY}/all`);
};

export const useGetIndustryList = ({ enabled = true } = {}) => {
  return useQuery([`${INDUSTRY}/all`], getIndustryList, {
    enabled,
    staleTime: CACHE_TIME,
    cacheTime: CACHE_TIME,
  });
};

const getIndustryById = ({ queryKey }) => {
  const [, id] = queryKey;
  return api.get(`${INDUSTRY}/${id}`);
};

export const useGetIndustryById = (id, { enabled = true } = {}) => {
  return useQuery([INDUSTRY, id], getIndustryById, {
    enabled: enabled && !!id,
  });
};

const postCreateIndustry = (payload) => api.post(INDUSTRY, payload);

export const usePostCreateIndustry = () => {
  const { addSnackbarSuccess } = useHubSnackBar();
  const queryClient = useQueryClient();

  return useMutation(postCreateIndustry, {
    onSuccess: () => {
      queryClient.invalidateQueries(INDUSTRY);
      queryClient.invalidateQueries(`${INDUSTRY}/all`);
      addSnackbarSuccess({ message: "Successfully Created Industry" });
    },
  });
};

const putUpdateIndustry = ({ id, ...payload }) =>
  api.put(`${INDUSTRY}/${id}`, payload);

export const usePutUpdateIndustry = () => {
  const { addSnackbarSuccess } = useHubSnackBar();
  const queryClient = useQueryClient();

  return useMutation(putUpdateIndustry, {
    onSuccess: () => {
      queryClient.invalidateQueries(INDUSTRY);
      queryClient.invalidateQueries(`${INDUSTRY}/all`);
      addSnackbarSuccess({ message: "Successfully Updated Industry" });
    },
  });
};

const deleteIndustry = (id) => api.delete(`${INDUSTRY}/${id}`);

export const useDeleteIndustry = () => {
  const { addSnackbarSuccess } = useHubSnackBar();
  const queryClient = useQueryClient();

  return useMutation(deleteIndustry, {
    onSuccess: () => {
      queryClient.invalidateQueries(INDUSTRY);
      queryClient.invalidateQueries(`${INDUSTRY}/all`);
      addSnackbarSuccess({ message: "Successfully Deleted Industry" });
    },
  });
};
